<template>
	<div class="tip-tap-component">
		<div class="editor" v-if="editor">
			<menu-bar class="editor__header" :editor="editor" />
			<editor-content class="editor__content" :editor="editor" />
		</div>
		<b-button variant="primary" class="float-right mt-3 px-5" @click="submitContent">Submit</b-button>
	</div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import MenuBar from '@/components/TipTap/MenuBar'
import Mention from '@tiptap/extension-mention'
import Underline from '@tiptap/extension-underline'
import Highlight from '@tiptap/extension-highlight'
import suggestion from '@/components/TipTap/suggestion.js'
import { axios, services, getHeader } from '@/assets/js/httpImports.js'
import { mapState, mapActions } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
// import { useNotificationStore } from '@/stores/notificationStore'
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'

export default {
	components: {
		EditorContent,
		MenuBar
	},
	props: {
		value: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			editor: null,
			mentionsList: new Set(),
			message_reply: '',
			editting: false,
		}
	},
	watch: {
		value(value) {
			const isSame = this.editor.getHTML() === value

			if (isSame) {
				return
			}
			
			this.editor.commands.setContent(value, false)
		},
		edit_message(message) {
			if (message !== null) {
				this.editting = true
				this.editor.commands.setContent(message.message_content, false)
			} else {
				this.editting = false
				this.editor.commands.setContent('', false)
			}
		}
	},
	mounted() {
		this.editor = new Editor({
			content: this.value,
			extensions: [
				StarterKit,
				Mention.configure({
					HTMLAttributes: {
						class: 'mention',
					},
					suggestion,
				}),
				Underline.configure({
					HTMLAttributes: {
						class: 'my-custom-class',
					},
				}),
				Highlight.configure({
					HTMLAttributes: {
						class: 'my-custom-class',
					},
				}),
			],
			onUpdate: () => {
				this.$emit('input', this.editor.getHTML())
			},
		})
	},
	beforeDestroy() {
		this.editor.destroy()
	},
	computed: {
   	...mapState(useMessagingStore,['selected_group', 'replying_to', 'edit_message', 'message_profile', 'parent_bundle_key']),
    },
	methods: {
		...mapActions(useMessagingStore,['getMessages', 'resetReplyTo']),
		// ...mapActions(useNotificationStore, ['createNotification']),		
		submitContent() {
			const data = {
				content: this.editor.getHTML(),
			}

			// Create a DOMParser instance and parse the HTML string
			const parser = new DOMParser()
			const htmlDoc = parser.parseFromString(data.content, 'text/html')

			// Use querySelectorAll to select all elements with the "mention" class
			const mentionElements = htmlDoc.querySelectorAll('.mention')

			// Extract the data-id values and store them in the mentions array
			const mentions = Array.from(mentionElements).map(element => element.getAttribute('data-id'))
			let mentionUserIds = [];
			mentions.forEach(selectedNames => {
				const participant = this.selected_group.group_participants.find(participant => participant.participant_fullname === selectedNames);
				if (participant) {
					this.mentionsList.add(participant.participant_id);
					mentionUserIds.push(participant.participant_user_id);
				}
			});

			if (!this.editting) {
				const createData = {
					message_group_id: this.selected_group.group_id,
					message_participant_id: _gAuth.activeMsgParticipantId(),
					message_reply_id: this.replying_to ? this.replying_to.message_id ?? null : null,
					message_content: data.content,
					message_application_code: _gAuth.appCode(),
					message_is_info: 0,
					message_mentions: Array.from(this.mentionsList) ?? null
				}

				axios.post(services.messaging + 'message', createData ,{ headers: getHeader() })
				.then ( response => {
					if (response.status === 201)
					{
						this.$notify({
							message:
							'<b>New Message: </b> - Successfully Created.',
							timeout: 10000,
							icon: 'ni ni-bell-55',
							type: 'success',
						});
						this.editor.commands.setContent('', false)
						this.resetReplyTo()
						this.getMessages(this.selected_group.group_id)
						chatEventBus.$emit('refresh-chat-box-button-'+this.parent_bundle_key)

						//TRIGGER UPDATE LAST MESSAGE DATE TO LEAD
						// if(this.message_profile.type == 'lead'){
						// 	let leadID = this.message_profile.lead_id;
						// 	if(!_gHlp.isEmpty(leadID)){
						// 		let leadUpdate = {
						// 			last_message_at: _gHlp.getCurrentDateTime()
						// 		}
						// 		try {
						// 			axios.put(services.lead + 'leads/' + leadID, leadUpdate, { headers: getHeader() });
						// 		} catch (e) {
						// 				_gNotif.errorFunction(e)
						// 				console.log('failed:' + e)
						// 		}
						// 	}
            // }

						//TRIGGER NOTIF BELL
						// if(!_gHlp.isEmpty(mentionUserIds) && !_gHlp.isEmpty(this.message_profile)){
						// 	const activeUser = _gAuth.activeUser();
						// 	let noti_url = window.location.origin + '/leadProfileDetails/' + this.message_profile.lead_id + '/?active=overview';
						// 	let noti_message = 'Lead ID: #' + this.message_profile.lead_id + ', You was tagged in messages by '+ activeUser.name;
						// 	let noti_related_type = 'lead';
						// 	let noti_related_id = this.message_profile.lead_id;
						// 	if(this.message_profile.type == 'customer'){
						// 		noti_url = window.location.origin + '/customerProfileDetails/' + this.message_profile.customer_id + '/?active=overview'
						// 		noti_message = 'Customer ID: #' + this.message_profile.customer_id + ', You was tagged in messages by '+ activeUser.name;
						// 		noti_related_type = 'customer';
						// 		noti_related_id = this.message_profile.customer_id;
						// 	}
						// 	let contentNotification = {
						// 		noti_message: noti_message,
						// 		noti_url: noti_url,
						// 		microservice_code: noti_related_type,
						// 		noti_related_type: noti_related_type,
						// 		noti_related_id: noti_related_id
						// 	}
						// 	for (const key in mentionUserIds) {
						// 		const user_id = mentionUserIds[key];
						// 		let notification = { ...contentNotification, noti_user_id: user_id }
						// 		this.createNotification(notification)
						// 	}
						// }
					}
				})
				.catch ( e => {
					_gNotif.errorFunction(e)
					_gNotif.cLog('Messaging Tiptap (submitContent - Create Message) failed: ' + e.response.data.message)
				});
			} else {
				const updateData = {
					message_group_id: this.selected_group.group_id,
					message_participant_id: _gAuth.activeMsgParticipantId(),
					message_reply_id: this.edit_message ? this.edit_message.message_reply_id ?? null : null,
					message_content: data.content,
					message_application_code: _gAuth.appCode(),
					message_is_info: 0,
					message_mentions: Array.from(this.mentionsList) ?? null
				}

				axios.post(services.messaging + 'message/' + this.edit_message.message_id, updateData ,{ headers: getHeader() })
				.then ( response => {
					if (response.status === 201)
					{
						this.$notify({
							message:
							'<b>New Message: </b> - Successfully Created.',
							timeout: 10000,
							icon: 'ni ni-bell-55',
							type: 'success',
						});
						this.editor.commands.setContent('', false)
						this.resetReplyTo()
						this.getMessages(this.selected_group.group_id)
					}
				})
				.catch ( e => {
					_gNotif.errorFunction(e)
					_gNotif.cLog('Messaging Tiptap (submitContent - Edit Message) failed: ' + e.response.data.message)
				});
			}

		},
	},
}
</script>